<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div v-if="loading">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
    <div v-if="!loading" class="m-3 col-md-9 col-lg-9">
      <div class="page_title">
        <h1 class="text-left">Youtube Video Content</h1>
      </div>
      <div class="row mt-3 border bg-white p-2">
        <div class="col-md-12">
          <div class="form-group">
            <label for="videoTitle">Title
              <span class="text-danger">*</span>
            </label>
            <input id="videoTitle" v-model="section_title" class="form-control" placeholder="Enter Section Title"
                   type="text">
          </div>
          <div class="form-group">
            <label for="videoDescription">Title (English)</label>
            <input id="videoDescription" v-model="section_title_en" class="form-control"
                   placeholder="Enter Section Title (English)"
                   type="text">
          </div>
        </div>

        <div class="col-md-12 mt-3">
          <draggable v-model="componentData" :animation="300" class="accordion">
            <template #item="{ element: accordion, index: index }">
              <div class="accordion-item mb-2">
                <h2 class="accordion-header ">
                  <button :aria-controls="'accordion-' + index"
                          :aria-expanded="false"
                          :data-bs-target="'#accordion-' + index" :data-bs-toggle="'collapse'"
                          :style="{ 'background-color': accordion.active_yn === 'Y' ? '#d8f2d0' : '#f2dad8' }"
                          class="accordion-button collapsed " @click="toggleAccordion(index)">
                    {{ accordion.title }}
                  </button>
                </h2>
                <div :id="'accordion-' + index" :class="{ show: accordion.open }"
                     :data-bs-parent="'#accordion-' + index"
                     class="accordion-collapse collapse" role="tabpanel">
                  <div class="accordion-body">
                    <div class="accordion-body">
                      <div class="mb-3">
                        <div class="input-label">Title
                          <span class="text-danger">*</span>
                        </div>
                        <input v-model="accordion.title" class="form-control" type="text">
                      </div>
                      <div class="mb-3">
                        <div class="input-label">Description</div>
                        <input v-model="accordion.description" class="form-control" type="text">
                      </div>
                      <div class="mb-3">
                        <div class="input-label">Youtube Link
                          <span class="text-danger">*</span>
                        </div>
                        <input v-model="accordion.video_url" class="form-control" type="text"
                               @change="checkYoutubeLink(accordion.video_url)">
                      </div>
                      <div v-if="accordion.id" class="mb-3">
                        <div class="input-label">Youtube Link Preview</div>
                        <iframe :src="accordion.video_url"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen frameborder="0"
                                height="315"
                                width="100%"></iframe>
                      </div>
                      <div class="d-flex flex-row ">
                        <div class="mt-2 col-md-6 col-lg-6">
                          <div class="d-flex flex-column my-1 col-md-7" style="display: flex;">
                            <div class="d-flex flex-row" style="align-items: center; flex-wrap: wrap; ">
                              <i class="fa-solid fa-calendar-days icon-publish"></i>
                              <div class="text-sx  ms-1">Expiry Date:</div>
                              <div v-if="accordion.expiry_date == null" class="text-sx  text-selected ms-1 me-auto"
                                   style="">
                                None
                              </div>
                              <div v-else class="text-sx align-self-center text-selected ms-1 me-auto" style="">
                                {{ expiryTimeFormat(accordion.expiry_date, index) }}
                              </div>
                              <button :aria-controls="'expiryDate-' + index"
                                      :data-bs-target="'#expiryDate-' + index"
                                      aria-expanded="false"
                                      class="btn x-small-btn border border-primary text-primary  mx-1 edit-button"
                                      data-bs-toggle=collapse role="button">
                                Edit
                              </button>
                            </div>

                            <div :id="'expiryDate-' + index" :data-bs-parent="'#expiryDate-' + index"
                                 class="collapse my-2">
                              <VueDatePicker v-model="accordion.expiry_date" auto-apply/>
                            </div>
                          </div>
                        </div>
                        <div class="mt-2 col-md-6 col-lg-6 " style="display: flex; ">
                          <div class="col-lg-6 col-md-4"></div>
                          <div class="col-lg-6 col-md-8">
                            <label class="form-label" for="active_yn">Visibility</label>
                            <select v-model="accordion.active_yn" :value="accordion.active_yn"
                                    aria-label="Default select example" class="form-select">
                              <option value="Y"><b>Yes</b></option>
                              <option value="N"><b>No</b></option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="mt-2">
                        <button v-if="accordion.id" class="btn btn-danger" type="button"
                                @click="deleteSection(accordion.id)">Delete
                        </button>
                        <button v-if="!accordion.id" class="btn btn-danger" type="button"
                                @click="componentData.splice(index, 1)">Remove
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </draggable>
        </div>

        <div>
          <div class="mt-2 mb-3">
            <button class="btn btn-dark me-3" style="height: 5vh; font-size: 16px;" type="button"
                    @click="addAccordion()">
              Add
            </button>
            <button class="btn btn-primary" style="height: 5vh; font-size: 16px;" type="button" @click="saveChanges">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import MediaService from "@/services/media.service";
import VueDatePicker from '@vuepic/vue-datepicker';
import {format_date_ddmmmyyyy} from "@/helpers";


export default {
  name: 'videoContent',
  components: {
    draggable,
    VueDatePicker,
  },
  data() {
    return {
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'Theme Options',
          to: '/portal-header'
        }, {
          text: 'Videos Options',
          href: '#'
        }
      ],
      nullTitle: false,
      loading: false,
      index: null,
      componentData: [],
      section_title: null,
      section_title_en: null,
      accordion: {
        title: null,
        description: null,
        video_url: null,
        expiry_date: null,
        open: false,

      },
      video: {
        id: null,
        section_title: null,
        section_title_en: null,
        contents: [
          {
            id: null,
            title: null,
            description: null,
            video_url: null,
            position: null,
          },
        ],
      },
      videosContent: {
        id: null,
      }
    }
  },
  methods: {
    addAccordion() {
      //check if last accordion is empty
      if (this.componentData.length > 0) {
        if (this.componentData[this.componentData.length - 1].video_url === null || this.componentData[this.componentData.length - 1].section_title === null || this.componentData[this.componentData.length - 1].section_title === '' || this.componentData[this.componentData.length - 1].video_url === '' || this.componentData[this.componentData.length - 1].section_title_en === '') {
          //show notification
          alert('Title and Youtube Link are Mandatory!!!')
          return;
        }
      }
      this.componentData.push({
        title: null,
        description: null,
        video_url: null,
        open: true,
        expiry_date: null,
        active_yn: null,
      });
      this.componentData[this.componentData.length - 2].open = false;
    }
    ,
    toggleAccordion(index) {
      this.componentData[index].open = !this.componentData[index].open;
    },

    formatDateDDMMMYYYY(value) {
      return format_date_ddmmmyyyy(value);
    },

    async deleteSection(id) {
      this.loading = true;
      //1st show confirmation
      this.videosContent.id = id;
      if (confirm('Are you sure you want to delete this section?')) {
        //delete
        try {
          const response = await MediaService.deleteVideoContent(this.videosContent);
          if (response.data) {
            this.loading = false;
            if (response.data.messageCode === 1) {
              this.showNotification('success', response.data.message)
              //remove from componentData
              this.componentData.splice(this.componentData.indexOf(this.componentData.find(item => item.id === id)), 1);
            } else {
              this.showNotification('error', response.data.message)
            }
          } else {
            alert('Something went wrong');
          }
        } catch (error) {
          console.log(error);
        }
      }
      this.loading = false;

    },
    showNotification(type, message) {
      this.$notify({
        type: type,
        title: 'Video Content',
        text: message
      });
    },
    expiryTimeFormat(date, index) {
      this.componentData[index].expiry_date_format = null;
      this.componentData[index].expiry_date_format = this.formatDateDDMMMYYYY(date);
      var mydate = new Date(date);

      const day = mydate.getDate();
      const month = mydate.getMonth() + 1;
      const year = mydate.getFullYear();

      return `${day}/${month}/${year}`;
    },
    dateFormat(date) {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },
    async saveChanges() {
      if (!this.setVideoData()) {
        return;
      }
      this.nullTitle = false;
      this.loading = true;
      try {
        const response = await MediaService.updateVideoContent(this.video);
        if (response.data) {
          this.loading = false;
          if (response.data.messageCode === 1) {
            this.showNotification('success', response.data.message);
          } else {
            this.showNotification('error', response.data.message);
          }
        } else {
          alert('Something went wrong');
        }
      } catch (error) {
        console.log(error);
      }


    },
    async getVideoContent() {
      this.loading = true;
      try {
        const response = await MediaService.getVideoContent();
        this.loading = false;
        this.video = response.data;
        this.section_title = this.video.section_title;
        this.section_title_en = this.video.section_title_en;
        this.componentData = this.video.contents;
        this.componentData.forEach((item) => {
          item.open = false;
        });

      } catch (error) {
        console.log(error);
      }

    },
    addHours(date, h) {
      const mydate = new Date(date);
      mydate.setTime(mydate.getTime() + h * 60 * 60 * 1000)
      return mydate;
    },
    setVideoData() {
      this.video.section_title = this.section_title;
      this.video.section_title_en = this.section_title_en;
      //set position to componentData
      this.componentData.forEach((item, index) => {
        item.position = index + 1;
        if (item.expiry_date) {
          item.expiry_date = new Date(item.expiry_date);
          item.expiry_date.setHours(14);
        }
      });
      this.componentData.forEach((item) => {
        if (item.title === null || item.title === '') {
          this.nullTitle = true;
          alert("Title is mandatory!!!")
          return false;
        }
        item.open = false;

      });
      if (this.nullTitle) {
        return;
      }
      this.video.contents = this.componentData;
      return true;
    },
    checkYoutubeLink(link) {
      if (link.includes('youtube.com')) {
        //get video id
        let videoId = link.split('v=')[1];
        //get ampersand position
        const ampersandPosition = videoId.indexOf('&');
        if (ampersandPosition !== -1) {
          videoId = videoId.substring(0, ampersandPosition);
        }
        //set video url
        this.accordion.video_url = 'https://www.youtube.com/embed/' + videoId;
      } else {
        alert('Please enter a valid youtube link');
        this.accordion.video_url = '';
      }
    }
  }
  ,
  mounted() {
    this.getVideoContent();
  },
  watch: {}

}
</script>
<style>
button.accordion-button {
  background-color: #e8e8e8;
  font-weight: 800;
}
</style>
